(function () {
  var matrix = {
    3: { label: 'Home Essential', panels: 18, modules: 4, inverter: 8 },
    4: { label: 'Home Smart', panels: 22, modules: 5, inverter: 10 },
    5: { label: 'Home Complete', panels: 28, modules: 6, inverter: 12 },
    6: { label: 'Home Complete', panels: 34, modules: 8, inverter: 15 }
  };
  var labels = {
    occupants: { '1-2': '1–2 occupants', '3-4': '3–4 occupants', '5-6': '5–6 occupants', '7+': '7+ occupants' },
    bill: { 'under-300': 'under $300', '300-600': '$300–$600', '600-1000': '$600–$1,000', 'over-1000': 'over $1,000', unsure: 'unsure' },
    existingSolar: { none: 'No existing solar', 'under-6.6': 'Under 6.6 kW', '6.6-10': '6.6–10 kW', 'over-10': 'Over 10 kW', unsure: 'Not sure' },
    goal: { bill: 'Maximum bill reduction', backup: 'Backup protection', ev: 'EV-ready energy', independence: 'Energy independence' },
    backup: { none: 'No backup', essential: 'Essential circuits', most: 'Most of the home', whole: 'Whole-home assessment', unsure: 'Not sure' },
    timing: { day: 'Mainly daytime', evening: 'Mainly evenings', 'all-day': 'Throughout the day', unsure: 'Not sure' },
    roof: { clear: 'Clear roof', some: 'Some shading', significant: 'Significant shading', unsure: 'Not sure' },
    vpp: { interested: 'Interested', benefits: 'Show me the benefits', no: 'Not interested', unsure: 'Not sure' },
    loads: { pool: 'Pool', 'ducted-ac': 'Ducted air conditioning', 'hot-water': 'Electric hot water', heating: 'Electric heating', 'granny-flat': 'Granny flat', 'home-business': 'Home business' },
    future: { 'another-ev': 'Another EV', pool: 'Pool', extension: 'Home extension', electrification: 'More electrification' }
  };

  function setPressed(buttons, activeButton) {
    buttons.forEach(function (button) {
      var active = button === activeButton;
      button.classList.toggle('is-active', active);
      if (button.getAttribute('role') === 'radio') {
        button.setAttribute('aria-checked', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      } else {
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    });
  }

  function setupRovingGroup(buttons) {
    if (!buttons.length) return;
    var container = buttons[0].parentElement;
    var fieldset = container && container.closest('fieldset');
    var legend = fieldset && fieldset.querySelector('legend');
    container.setAttribute('role', 'radiogroup');
    if (legend) container.setAttribute('aria-label', legend.textContent.trim());
    buttons.forEach(function (button, index) {
      var active = button.classList.contains('is-active') || button.getAttribute('aria-pressed') === 'true';
      button.setAttribute('role', 'radio');
      button.setAttribute('aria-checked', active ? 'true' : 'false');
      button.removeAttribute('aria-pressed');
      button.tabIndex = active ? 0 : -1;
      button.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        buttons[nextIndex].click();
        buttons[nextIndex].focus();
      });
    });
  }

  function toggleMulti(button, selected, value) {
    var index = selected.indexOf(value);
    if (index === -1) selected.push(value);
    else selected.splice(index, 1);
    var active = selected.indexOf(value) !== -1;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function listLabels(values, map) {
    return values.length ? values.map(function (value) { return map[value]; }).join(', ') : 'None selected';
  }

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function initialise(root) {
    if (root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    var state = {
      bedrooms: 4,
      occupants: '3-4',
      bill: '300-600',
      type: 'solar-battery',
      existingSolar: 'none',
      evs: 0,
      phase: 'single',
      goal: 'bill',
      backup: 'essential',
      timing: 'all-day',
      roof: 'unsure',
      vpp: 'benefits',
      loads: [],
      future: []
    };

    var groups = {
      size: Array.prototype.slice.call(root.querySelectorAll('[data-home-size]')),
      occupants: Array.prototype.slice.call(root.querySelectorAll('[data-occupants]')),
      bill: Array.prototype.slice.call(root.querySelectorAll('[data-bill]')),
      type: Array.prototype.slice.call(root.querySelectorAll('[data-system-type]')),
      existingSolar: Array.prototype.slice.call(root.querySelectorAll('[data-existing-solar]')),
      evs: Array.prototype.slice.call(root.querySelectorAll('[data-ev-count]')),
      phase: Array.prototype.slice.call(root.querySelectorAll('[data-phase]')),
      goal: Array.prototype.slice.call(root.querySelectorAll('[data-goal]')),
      backup: Array.prototype.slice.call(root.querySelectorAll('[data-backup]')),
      timing: Array.prototype.slice.call(root.querySelectorAll('[data-timing]')),
      roof: Array.prototype.slice.call(root.querySelectorAll('[data-roof]')),
      vpp: Array.prototype.slice.call(root.querySelectorAll('[data-vpp]')),
      loads: Array.prototype.slice.call(root.querySelectorAll('[data-load]')),
      future: Array.prototype.slice.call(root.querySelectorAll('[data-future]'))
    };
    var postcode = root.querySelector('[data-postcode]');
    var leadForm = root.querySelector('.hps-lead-form');
    var leadEmail = root.querySelector('[data-lead-email]');
    var leadPhone = root.querySelector('[data-lead-phone]');
    var leadAddress = root.querySelector('[data-lead-address]');
    var leadConsent = root.querySelector('[data-lead-consent]');
    var leadError = root.querySelector('[data-lead-error]');
    var packageBodyField = root.querySelector('[data-package-body]');
    var packageField = root.querySelector('[data-package-field]');
    var answersField = root.querySelector('[data-answers-field]');

    function output(name, value) {
      var element = root.querySelector('[data-' + name + ']');
      if (element) element.textContent = value;
    }

    function render() {
      var base = matrix[state.bedrooms];
      var panels = base.panels + (state.evs * 6);
      var modules = base.modules + (state.evs * 2);
      var inverterAdjustment = 0;

      if (state.occupants === '1-2') { panels -= 2; modules -= 1; }
      if (state.occupants === '5-6') { panels += 2; modules += 1; }
      if (state.occupants === '7+') { panels += 4; modules += 2; }

      if (state.bill === 'under-300') { panels -= 2; modules -= 1; }
      if (state.bill === '600-1000') { panels += 4; modules += 1; }
      if (state.bill === 'over-1000') { panels += 8; modules += 2; }

      if (state.type === 'battery-only') {
        if (state.existingSolar === '6.6-10') modules += 1;
        if (state.existingSolar === 'over-10') modules += 2;
      }

      if (state.goal === 'backup') modules += 1;
      if (state.goal === 'ev' && state.evs === 0) { panels += 6; modules += 2; }
      if (state.goal === 'independence') { panels += 4; modules += 2; }

      if (state.backup === 'essential' || state.backup === 'unsure') modules += 1;
      if (state.backup === 'most') { modules += 2; inverterAdjustment += 2; }
      if (state.backup === 'whole') { panels += 4; modules += 3; inverterAdjustment += 4; }

      if (state.timing === 'day') { panels += 2; modules -= 1; }
      if (state.timing === 'evening') modules += 1;

      state.loads.forEach(function (load) {
        if (load === 'pool') panels += 2;
        if (load === 'ducted-ac') { panels += 2; modules += 1; }
        if (load === 'hot-water') panels += 2;
        if (load === 'heating') { panels += 2; modules += 1; }
        if (load === 'granny-flat') { panels += 4; modules += 1; }
        if (load === 'home-business') panels += 2;
      });

      state.future.forEach(function (future) {
        if (future === 'another-ev') { panels += 6; modules += 2; }
        if (future === 'pool') panels += 2;
        if (future === 'extension') { panels += 4; modules += 1; }
        if (future === 'electrification') { panels += 4; modules += 1; }
      });

      modules = clamp(modules, 3, 15);
      if (state.type === 'battery-only') panels = 0;
      else panels = clamp(panels, 12, 50);

      var solarKw = panels * 0.475;
      var batteryKwh = modules * 5.12;
      var resolvedPhase = state.phase === 'three' ? 'three' : 'single';
      var solarDrivenInverter = panels ? Math.round(solarKw * .75) : base.inverter;
      var requestedInverterKw = clamp(Math.max(base.inverter + (state.evs * 2) + inverterAdjustment, solarDrivenInverter), 5, 20);
      var inverterKw = resolvedPhase === 'single' ? Math.min(10, requestedInverterKw) : requestedInverterKw;
      var requiresStagedDesign = resolvedPhase === 'single' && requestedInverterKw > 10;
      var goalSuffix = { bill: 'Savings', backup: 'Resilience', ev: 'EV-ready', independence: 'Independence' }[state.goal];
      var title = base.label + ' ' + goalSuffix + (state.evs ? ' + ' + state.evs + ' EV' : '');
      var systemLabel = state.type === 'solar-battery' ? 'Solar + battery' : 'Battery only';
      var postcodeValue = postcode && postcode.value.trim() ? postcode.value.trim() : 'Not supplied';
      var customerEmail = leadEmail && leadEmail.value.trim() ? leadEmail.value.trim() : 'Not supplied';
      var customerPhone = leadPhone && leadPhone.value.trim() ? leadPhone.value.trim() : 'Not supplied';
      var customerAddress = leadAddress && leadAddress.value.trim() ? leadAddress.value.trim() : 'Not supplied';
      var postcodeIsNsw = /^2\d{3}$/.test(postcodeValue);
      var postcodeIsComplete = /^\d{4}$/.test(postcodeValue);
      var phaseSelectedLabel = state.phase === 'three' ? 'Three phase' : (state.phase === 'unsure' ? 'Not sure' : 'Single phase');
      var phaseAssumptionLabel = resolvedPhase === 'three' ? 'Three phase' : 'Single phase';
      var phaseBadge = state.phase === 'unsure' ? '1Ø ASSUMED' : (resolvedPhase === 'three' ? '3Ø' : '1Ø');
      var existingSolarLabel = labels.existingSolar[state.existingSolar];
      var inverterDetail = resolvedPhase === 'three'
        ? 'Solis three-phase hybrid platform; exact model confirmed during design.'
        : (state.phase === 'unsure'
          ? 'Single-phase Solis design used as the default assumption; supply confirmed before final design.'
          : 'Solis single-phase hybrid platform; exact model confirmed during design.');
      if (requiresStagedDesign) inverterDetail += ' The larger package may require a staged or additional-inverter design.';

      var solarValue = state.type === 'solar-battery' ? solarKw.toFixed(2) + ' kW' : 'Existing solar';
      var solarDetail = state.type === 'solar-battery'
        ? panels + ' × Risen 475 W panels'
        : existingSolarLabel + '; array, inverter and export compatibility assessed before design.';
      var solarLine = state.type === 'solar-battery'
        ? panels + ' × Risen 475 W (' + solarKw.toFixed(2) + ' kW)'
        : existingSolarLabel + ' system to be assessed';
      var capacityNote = modules === 15 ? ' The recommendation reaches the maximum nominal capacity of one STACK100 Pro cluster; final architecture is confirmed during assessment.' : '';
      var roofNote = state.roof === 'significant' ? ' Significant shading is flagged for detailed roof design.' : (state.roof === 'unsure' ? ' Roof fit and shading will be confirmed.' : '');
      var loadNote = state.loads.length ? ' Includes allowances for ' + listLabels(state.loads, labels.loads).toLowerCase() + '.' : '';
      var summary = 'Balanced for a ' + state.bedrooms + '-bedroom home, ' + labels.occupants[state.occupants].toLowerCase() + ', a ' + labels.bill[state.bill] + ' quarterly bill, ' + labels.goal[state.goal].toLowerCase() + ', ' + labels.backup[state.backup].toLowerCase() + ' and ' + labels.timing[state.timing].toLowerCase() + ' energy use.' + loadNote + roofNote + capacityNote;

      output('package-name', title);
      output('package-badge', state.bedrooms + ' BED · ' + state.evs + ' EV · ' + phaseBadge);
      output('solar-value', solarValue);
      output('solar-detail', solarDetail);
      output('battery-value', batteryKwh.toFixed(2) + ' kWh');
      output('battery-detail', modules + ' × 5.12 kWh STACK100 Pro modules, nominal');
      output('inverter-value', inverterKw + ' kW ' + (resolvedPhase === 'three' ? 'three-phase' : 'single-phase'));
      output('inverter-detail', inverterDetail);
      output('recommendation-summary', summary);
      output('stc-value', state.type === 'solar-battery' ? 'Calculated using postcode and installation date' : 'Not applicable to a battery-only package');
      output('prc-value', postcodeIsNsw ? 'NSW eligibility and certificate value confirmed separately' : (postcodeIsComplete ? 'NSW PRC not assumed; applicable state incentives checked separately' : 'Eligibility and certificate value confirmed separately'));
      output('vpp-value', { interested: 'Include participating-provider offers in the comparison', benefits: 'Provider benefits and operating terms shown separately', no: 'Excluded from the requested package', unsure: 'Optional provider offers shown separately' }[state.vpp]);
      output('package-status', 'Recommendation updated: ' + title + ', ' + solarValue + ' solar, ' + batteryKwh.toFixed(2) + ' kWh battery and ' + inverterKw + ' kW ' + phaseAssumptionLabel.toLowerCase() + ' inverter pathway.');

      var subject = 'Home energy package assessment — ' + title;
      var body = [
        'I would like a site-specific assessment for the ' + title + ' indicative package.',
        '',
        'Customer email: ' + customerEmail,
        'Customer phone: ' + customerPhone,
        'Installation address: ' + customerAddress,
        'Postcode: ' + postcodeValue,
        'Home: ' + state.bedrooms + ' bedrooms; ' + labels.occupants[state.occupants],
        'Average quarterly bill: ' + labels.bill[state.bill],
        'System: ' + systemLabel,
        'Existing solar: ' + existingSolarLabel,
        'EVs: ' + state.evs,
        'Supply phase selected: ' + phaseSelectedLabel,
        'Package phase assumption: ' + phaseAssumptionLabel,
        'Main goal: ' + labels.goal[state.goal],
        'Backup: ' + labels.backup[state.backup],
        'Energy-use timing: ' + labels.timing[state.timing],
        'Major loads: ' + listLabels(state.loads, labels.loads),
        'Future plans: ' + listLabels(state.future, labels.future),
        'Roof: ' + labels.roof[state.roof],
        'VPP preference: ' + labels.vpp[state.vpp],
        '',
        'Indicative solar: ' + solarLine,
        'Indicative battery: ' + modules + ' × 5.12 kWh Dyness STACK100 Pro modules (' + batteryKwh.toFixed(2) + ' kWh nominal)',
        'Indicative inverter: Solis ' + phaseAssumptionLabel.toLowerCase() + ' hybrid platform, ' + inverterKw + ' kW design class' + (requiresStagedDesign ? ' with staged/additional-inverter design to be assessed' : ''),
        '',
        'Please confirm final sizing, installed price and the separate STC, PRC and VPP amounts.',
        '$500 cashback requested, subject to eligibility and the terms confirmed in the formal proposal.'
      ].join('\n');
      var answerSummary = [
        state.bedrooms + ' bedrooms', labels.occupants[state.occupants], labels.bill[state.bill] + ' quarterly bill', systemLabel,
        'Existing solar: ' + existingSolarLabel, state.evs + ' EV', phaseSelectedLabel, labels.goal[state.goal], labels.backup[state.backup],
        labels.timing[state.timing], 'Loads: ' + listLabels(state.loads, labels.loads), 'Future: ' + listLabels(state.future, labels.future),
        labels.roof[state.roof], 'VPP: ' + labels.vpp[state.vpp]
      ].join(' | ');
      if (packageBodyField) packageBodyField.value = body;
      if (packageField) packageField.value = title + ' — ' + solarValue + ' solar; ' + batteryKwh.toFixed(2) + ' kWh battery; ' + inverterKw + ' kW ' + phaseAssumptionLabel.toLowerCase() + ' inverter pathway';
      if (answersField) answersField.value = answerSummary;
      var emailLink = root.querySelector('[data-package-email]');
      if (emailLink) emailLink.href = 'mailto:' + root.dataset.contactEmail + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }

    [groups.size, groups.occupants, groups.bill, groups.type, groups.existingSolar, groups.evs, groups.phase, groups.goal, groups.backup, groups.timing, groups.roof, groups.vpp].forEach(setupRovingGroup);

    groups.size.forEach(function (button) { button.addEventListener('click', function () { state.bedrooms = Number(button.dataset.homeSize); setPressed(groups.size, button); render(); }); });
    groups.occupants.forEach(function (button) { button.addEventListener('click', function () { state.occupants = button.dataset.occupants; setPressed(groups.occupants, button); render(); }); });
    groups.bill.forEach(function (button) { button.addEventListener('click', function () { state.bill = button.dataset.bill; setPressed(groups.bill, button); render(); }); });
    groups.type.forEach(function (button) {
      button.addEventListener('click', function () {
        state.type = button.dataset.systemType;
        setPressed(groups.type, button);
        if (state.type === 'battery-only' && state.existingSolar === 'none') {
          state.existingSolar = 'unsure';
          setPressed(groups.existingSolar, groups.existingSolar.filter(function (item) { return item.dataset.existingSolar === 'unsure'; })[0]);
        }
        render();
      });
    });
    groups.existingSolar.forEach(function (button) {
      button.addEventListener('click', function () {
        state.existingSolar = button.dataset.existingSolar;
        setPressed(groups.existingSolar, button);
        if (state.existingSolar === 'none' && state.type === 'battery-only') {
          state.type = 'solar-battery';
          setPressed(groups.type, groups.type.filter(function (item) { return item.dataset.systemType === 'solar-battery'; })[0]);
        }
        render();
      });
    });
    groups.evs.forEach(function (button) { button.addEventListener('click', function () { state.evs = Number(button.dataset.evCount); setPressed(groups.evs, button); render(); }); });
    groups.phase.forEach(function (button) { button.addEventListener('click', function () { state.phase = button.dataset.phase; setPressed(groups.phase, button); render(); }); });
    groups.goal.forEach(function (button) { button.addEventListener('click', function () { state.goal = button.dataset.goal; setPressed(groups.goal, button); render(); }); });
    groups.backup.forEach(function (button) { button.addEventListener('click', function () { state.backup = button.dataset.backup; setPressed(groups.backup, button); render(); }); });
    groups.timing.forEach(function (button) { button.addEventListener('click', function () { state.timing = button.dataset.timing; setPressed(groups.timing, button); render(); }); });
    groups.roof.forEach(function (button) { button.addEventListener('click', function () { state.roof = button.dataset.roof; setPressed(groups.roof, button); render(); }); });
    groups.vpp.forEach(function (button) { button.addEventListener('click', function () { state.vpp = button.dataset.vpp; setPressed(groups.vpp, button); render(); }); });
    groups.loads.forEach(function (button) { button.addEventListener('click', function () { toggleMulti(button, state.loads, button.dataset.load); render(); }); });
    groups.future.forEach(function (button) { button.addEventListener('click', function () { toggleMulti(button, state.future, button.dataset.future); render(); }); });
    if (postcode) postcode.addEventListener('input', render);
    [leadEmail, leadPhone, leadAddress].forEach(function (input) { if (input) input.addEventListener('input', render); });
    if (leadForm) {
      leadForm.addEventListener('submit', function (event) {
        var hasEmail = leadEmail && leadEmail.value.trim() && leadEmail.checkValidity();
        var hasPhone = leadPhone && leadPhone.value.trim() && leadPhone.checkValidity();
        var hasConsent = leadConsent && leadConsent.checked;
        [leadEmail, leadPhone, leadConsent].forEach(function (input) {
          if (!input) return;
          input.removeAttribute('aria-invalid');
          input.removeAttribute('aria-describedby');
        });
        if (leadError) { leadError.hidden = true; leadError.textContent = ''; }
        function showError(input, message) {
          event.preventDefault();
          if (leadError) { leadError.textContent = message; leadError.hidden = false; }
          if (input) {
            input.setAttribute('aria-invalid', 'true');
            if (leadError && leadError.id) input.setAttribute('aria-describedby', leadError.id);
            input.focus();
          }
        }
        if (!hasEmail) {
          showError(leadEmail, 'Please enter a valid email address to request a callback.');
          return;
        }
        if (!hasPhone) {
          showError(leadPhone, 'Please enter a phone number to request a callback.');
          return;
        }
        if (!hasConsent) {
          showError(leadConsent, 'Please confirm that Moebotics Energy may contact you about this assessment.');
          return;
        }
        render();
      });
    }
    [leadEmail, leadPhone, leadConsent].forEach(function (input) {
      if (!input) return;
      input.addEventListener(input.type === 'checkbox' ? 'change' : 'input', function () {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
      });
    });
    var returnedFeedback = root.querySelector('.hps-form-message--success, .hps-form-message--error:not([hidden])');
    if (returnedFeedback) window.setTimeout(function () { returnedFeedback.focus(); }, 50);
    render();
  }

  function initialiseAll() {
    document.querySelectorAll('[data-home-package-selector]').forEach(initialise);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
